import { withMetadata } from '../metadata'
import { parsePhoneNumberWithError as _parsePhoneNumberWithError } from '../../core/index'

export function parsePhoneNumberWithError() {
	return withMetadata(_parsePhoneNumberWithError, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/parsePhoneNumberWithError.js
// module id = 603
// module chunks = 0